import React, { useState, useEffect } from "react";
import DataTable from "../../../components/DataTable";
import { apiJson } from "../../../utils/api";

const FeeRules = () => {
  const [feeHeads, setFeeHeads] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [degrees, setDegrees] = useState([]);

  useEffect(() => {
    apiJson("/api/admin/master/fee-heads").then(setFeeHeads).catch(() => {});
    apiJson("/api/admin/master/academic-sessions").then(setSessions).catch(() => {});
    apiJson("/api/admin/master/degrees").then(setDegrees).catch(() => {});
  }, []);

  return (
    <DataTable
      title="Fee Rules"
      apiPath="/api/admin/master/fee-rules"
      columns={[
        { key: "id", label: "ID" },
        { label: "Fee Head", render: (item) => item.feeHead?.name || "-" },
        { label: "Session", render: (item) => item.academicSession?.name || "-" },
        { label: "Degree", render: (item) => item.degree?.name || "All" },
        { key: "boardType", label: "Board" },
        { key: "casteCategory", label: "Caste" },
        { key: "gender", label: "Gender" },
        { key: "amount", label: "Amount" },
      ]}
      formFields={[
        {
          key: "feeHeadId",
          label: "Fee Head",
          type: "select",
          required: true,
          options: feeHeads.map((f) => ({ value: f.id, label: f.name })),
        },
        {
          key: "academicSessionId",
          label: "Academic Session",
          type: "select",
          required: true,
          options: sessions.map((s) => ({ value: s.id, label: s.name })),
        },
        {
          key: "degreeId",
          label: "Degree (blank = all)",
          type: "select",
          options: [{ value: "", label: "All Degrees" }, ...degrees.map((d) => ({ value: d.id, label: d.name }))],
        },
        { key: "boardType", label: "Board Type (blank = all)" },
        { key: "casteCategory", label: "Caste Category (blank = all)" },
        { key: "gender", label: "Gender (blank = all)" },
        { key: "amount", label: "Amount", type: "number", step: "0.01", required: true },
      ]}
    />
  );
};

export default FeeRules;
